<template>
  <el-dialog :visible.sync="isOpen" custom-class="b-condition-search-more c-condition-newyorker" width="550px" :show-close="false">
    <template slot="title">
      <h1 class="title">搜索更多</h1>
      <i class="iconfont iconguanbi" @click="close"></i>
    </template>
    <div class="search-for-more clearfix">
      <div class="b-con-form">
        <label class="c-label">来源方式：</label>
        <el-select class="c-input-area" popper-class="condition-popover-style" v-model="parameter.source" placeholder="请选择" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(channel, key) in options.customer_online_sources" :key="key" :label="channel" :value="key"></el-option>
        </el-select>
      </div>
      <div class="b-con-form mr0">
        <label class="c-label">来源渠道：</label>
        <el-select class="c-input-area" popper-class="condition-popover-style" v-model="parameter.channel" placeholder="请选择" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(channel, key) in options.customer_online_channels_2" :key="key" :label="channel" :value="key"></el-option>
        </el-select>
      </div>
      <div class="b-con-form" style="margin-right: 4%;">
        <label class="c-label">来源终端：</label>
        <el-select class="c-input-area" popper-class="condition-popover-style" v-model="parameter.terminal" placeholder="请选择" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(channel, key) in options.customer_terminals" :key="key" :label="channel" :value="key"></el-option>
        </el-select>
      </div>
      <div class="b-con-form" style="margin-right: 0;">
        <label class="c-label">来源平台：</label>
        <el-select class="c-input-area" popper-class="condition-popover-style" v-model="parameter.platform_id" placeholder="请选择" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(platform, key) in platformlist" :key="key" :label="platform.show_name" :value="platform.id"></el-option>
        </el-select>
      </div>
      <div class="b-con-form" style="margin-right: 0;">
        <label class="c-label">被分配人：</label>
        <el-cascader class="c-input-area" v-model="parameter.owner_admin_id" placeholder="请选择" :key="'dept_' + isResouceShow" :options="departmentList" :props="{emitPath: false, expandTrigger: 'click', value: 'id', label: 'name'}" :show-all-levels="false" ref="customeSelect" />
      </div>
      <div class="b-con-form" style="margin-right: 0;width: 80%;">
        <label class="c-label">分配时间：</label>
        <el-date-picker class="c-input-area time-picker-con" v-model="operateTimeList" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="right" :props="{ expandTrigger: 'click', value: 'id', label: 'name'}" clearable @change="operateTimeChange()" />
      </div>
      <div class="b-con-form" style="margin-right: 0;width: 80%;">
        <label class="c-label">客户创建时间：</label>
        <el-date-picker class="c-input-area time-picker-con" v-model="createTimeList" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="right" :props="{ expandTrigger: 'click', value: 'id', label: 'name'}" clearable @change="createTimeChange()" />
      </div>
    </div>
    <div slot="footer" class="more-condition-footer">
      <button class="global-btn info-round" @click="close">取消</button>
      <button class="global-btn primary-round" @click="resetCondition">重置</button>
      <button class="global-btn primary" @click="check">选择</button>
    </div>
  </el-dialog>
</template>
<script>
import {configKeys} from '@/setting/index';
import {getPlatformSelect} from '@/api/custome';
import {getAllCompanyMember} from '@/api/base';
export default{
  name: 'YorkerCondition',
  props: {
    isOpen: Boolean
  },
  data () {
    return {
      options: {},
      parameter: {
        owner_admin_id: -1
      },
      platformlist: [],
      isResouceShow: 0,
      departmentList: [],
      operateTimeList: [],
      createTimeList: []
    }
  },
  async created() {
    this.defaultData = {
      source: '',
      terminal: '',
      channel: '',
      owner_admin_id: -1,
      customer_created_at_end: '',
      customer_created_at_start: ''
    }
    const keys = [configKeys.customer_terminals, 'customer_online_channels_2','customer_online_sources'];
    this.options = await this.$store.dispatch('initConfig', keys);
    this.initPlatform();
    this.initDepartment();
  },
  methods: {
    close () {
      this.$emit('update:isOpen', false);
    },
    resetCondition () {
      this.parameter = {
        ...this.defaultData
      }
      this.$emit('reset', this.parameter);
      this.operateTimeList = [];
      this.createTimeList = [];
      this.close();
    },
    check () {
      const data = {...this.parameter};
      if (data.owner_admin_id < 0) data.owner_admin_id = 0;
      this.$emit('comfirmCheck', data);
      this.close();
    },
    changeParams (condition) {
      this.parameter = {
        ...this.defaultData,
        ...condition,
        owner_admin_id: !condition.owner_admin_id ? -1 : condition.owner_admin_id
      }
    },
    async initPlatform () {
      try {
        const res = await getPlatformSelect();
        this.platformlist = res;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    // 获取客户归属筛选列表
    async initDepartment () {
      this.isResouceShow += 1;
      try {
        const res = await getAllCompanyMember({
          is_all: 0,
          is_active:0
        });
        const list = res ?? [];
        list.unshift({
          id: -1,
          name: '全部'
        })
        this.departmentList = list;
      } catch (error) {
        console.log('获取部门筛选列表错误：', error);
      }
    },
    operateTimeChange () {
      this.parameter.created_at_start = this.operateTimeList?.[0] || '';
      this.parameter.created_at_end = this.operateTimeList?.[1] || '';
    },
    createTimeChange () {
      this.parameter.customer_created_at_start = this.createTimeList?.[0] || '';
      this.parameter.customer_created_at_end = this.createTimeList?.[1] || '';
    }
  },
}
</script>
<style lang="less">
.b-condition-search-more.c-condition-newyorker .search-for-more .c-label{
  width: 100px;
}
.b-condition-search-more.c-condition-newyorker .el-date-editor .el-range__close-icon{
  width: 22px;
  line-height: 24px;
}
</style>
